import dayjs from 'dayjs';
import type { DailyInsectCounts, RegionalOverviewDigitalTrapsProperties } from 'querys/regional-overview/regional-overview.query.models';
import type { RiskLevel } from '../domain';

export const calculateRiskLevelFromThreshold = (
  total: number | string,
  thresholds: RegionalOverviewDigitalTrapsProperties['threshold']
): RiskLevel => {
  if (total === '--' || typeof total !== 'number') {
    return 'not_applicable';
  }

  if (!thresholds || thresholds.length === 0) {
    return 'no_threshold';
  }

  for (const threshold of thresholds) {
    const { min, max, level } = threshold;

    if (max === null) {
      if (total >= min) {
        return level as RiskLevel;
      }
    } else if (total >= min && total <= max) {
      return level as RiskLevel;
    }
  }

  return 'not_applicable';
};

const DATE_KEY_PATTERN = /^\d{4}-\d{2}-\d{2}/;

export const toDateKey = (date: string): string => (DATE_KEY_PATTERN.test(date) ? date.slice(0, 10) : dayjs(date).format('YYYY-MM-DD'));

export const mapDailyCountsKeys = (dailyInsectCounts: DailyInsectCounts[], dateKeys: string[]) => {
  const countsByDateKey = new Map<string, DailyInsectCounts>();
  dailyInsectCounts.forEach(dailyCount => {
    const dateKey = toDateKey(dailyCount.date);
    if (!countsByDateKey.has(dateKey)) {
      countsByDateKey.set(dateKey, dailyCount);
    }
  });

  const mapped: Record<string, string | number> = {};
  let trapCount = 0;
  let hasCountData = false;

  dateKeys.forEach(dateKey => {
    const dailyCount = countsByDateKey.get(dateKey);
    mapped[dateKey] = dailyCount?.total ?? '--';
    if (dailyCount) {
      hasCountData = true;
      trapCount += dailyCount.total;
    }
  });

  return { mapped, trapCount, hasCountData };
};
